import { PlusOutlined } from "@ant-design/icons";
import { Button, Tabs } from "antd";
import { OrganizationTreeSelect } from "@/modules/organization-cross-access/components/OrganizationTreeSelect";
import { EmptyState } from "@/shared/components/EmptyState";
import { PageHeader } from "@/shared/components/PageHeader";
import { TableToolbar } from "@/shared/components/TableToolbar";
import { useUrlParam } from "@/shared/hooks/useUrlState";
import { PlantingsMap } from "../components/PlantingsMap";
import { PlantingsTable } from "../components/PlantingsTable";
import { usePlantingsStore } from "../store/plantings.store";

export function PlantingsPage() {
	// Selected org and active view live in the URL so back/forward restores them.
	const [orgId, setOrgId] = useUrlParam("org");
	const [view, setView] = useUrlParam("view", "list");
	const openCreateModal = usePlantingsStore((s) => s.openCreateModal);

	return (
		<div>
			<PageHeader
				title="Ekinlar"
				action={
					<Button
						type="primary"
						icon={<PlusOutlined />}
						disabled={!orgId}
						onClick={() => orgId && openCreateModal(orgId)}
					>
						Ekin qo'shish
					</Button>
				}
			/>

			<TableToolbar
				filters={
					<div className="min-w-[260px] max-w-[360px] flex-1">
						<OrganizationTreeSelect value={orgId} onChange={(value) => setOrgId(value || null)} />
					</div>
				}
			/>

			{orgId ? (
				<Tabs
					activeKey={view}
					onChange={setView}
					items={[
						{
							key: "list",
							label: "Ro'yxat",
							children: <PlantingsTable organizationId={orgId} />,
						},
						{
							key: "map",
							label: "Xarita",
							children: <PlantingsMap organizationId={orgId} />,
						},
					]}
				/>
			) : (
				<EmptyState description="Tashkilotni tanlang" />
			)}
		</div>
	);
}
